import { useLocalize } from '@treams/treams-hooks';
import * as graphql from '@treams/treams-network';
import { Heading } from '@treams/treams-ui';

export default function Title(props: { item: graphql.EvaluationTitleItem; readonly?: boolean }) {
	const { localize } = useLocalize();

	return <Heading>{localize(props.item.text).text}</Heading>;
}
